import axios from "axios";

// Dynamically determine backend URL based on current domain
const getBackendURL = () => {
  const currentDomain = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;
  
  // Development environment (localhost with port 3000)
  // Return same origin so the dev server proxy handles /api calls
  if ((currentDomain === 'localhost' || currentDomain === '127.0.0.1') && port === '3000') {
    console.log('🛠️ Detected development environment - using proxy');
    return `${protocol}//${currentDomain}:${port}`;
  }
  
  // PRODUCTION URL for iOS/Android app (Capacitor)
  // Capacitor apps load from capacitor://localhost, ionic://, file://, or localhost without port
  const isCapacitorApp = 
    protocol === 'capacitor:' || 
    protocol === 'ionic:' ||
    protocol === 'file:' || 
    ((currentDomain === 'localhost' || currentDomain === '127.0.0.1') && !port) ||
    window.Capacitor?.isNativePlatform?.();
  
  if (isCapacitorApp) {
    // Use production API for iOS/Android builds
    console.log('📱 Detected native app - using production API');
    return 'https://app.safetymindai.com';
  }
  
  // For ALL other domains (emergent preview OR custom domains), 
  // use the same domain with /api routing through ingress
  console.log('🌐 Detected web app - using current domain');
  return `${protocol}//${currentDomain}`;
};

const BACKEND_URL = getBackendURL();
export const API = `${BACKEND_URL}/api`;

console.log('🔗 Backend URL:', BACKEND_URL);
console.log('🔗 Full API URL:', API);

export const axiosInstance = axios.create({
  baseURL: API,
  timeout: 180000, // 180 second (3 min) timeout for AI operations
});

// Add auth token to requests and handle Content-Type
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Only set Content-Type to JSON if not FormData
  // FormData needs multipart/form-data with boundary, which browser sets automatically
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }
  
  // Extended timeout for AI-heavy endpoints (JHA, audit analysis)
  if (config.url?.includes('ai-suggestions') || 
      config.url?.includes('pre-construction-jha') ||
      config.url?.includes('/analyze')) {
    config.timeout = 300000; // 5 minutes for AI operations
  }
  
  return config;
});

// Browser navigations (window.open, <a href>, <img src>) carry no Authorization header, so every
// protected file has to be fetched through axios and handed to the browser as a blob.
export const downloadAuthed = async (path, filename) => {
  const res = await axiosInstance.get(path, { responseType: 'blob' });
  const href = URL.createObjectURL(res.data);
  const link = document.createElement('a');
  link.href = href;
  link.download = filename || path.split('/').pop();
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10000);
};

export const openAuthed = async (path) => {
  const res = await axiosInstance.get(path, { responseType: 'blob' });
  const href = URL.createObjectURL(res.data);
  window.open(href, '_blank');
  setTimeout(() => URL.revokeObjectURL(href), 60000);
};
